var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"pa-5 pa-sm-10",attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"mx-auto",attrs:{"sm":"11","lg":"9"}},[_c('h1',{domProps:{"textContent":_vm._s(_vm.$t('groups.groupsCreation'))}}),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }